import { SvgIcon, type SvgIconProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

interface T4loLogoIconProps extends Omit<SvgIconProps, 'children'> {
    width?: number;
    height?: number;
}

const T4loLogoIcon: React.FC<T4loLogoIconProps> = ({ width = 48, height = 48, ...props }) => {
    const theme = useTheme();

    return (
        <SvgIcon
            {...props}
            sx={{
                width,
                height,
                ...props.sx,
            }}
            viewBox="110 110 180 180"
        >
            {/* Primary Color - Upper right element */}
            <path
                fill={theme.palette.primary.main}
                d="M254.41,118.59h27.28v40.49c0,12.06-9.79,21.86-21.86,21.86h-26.53v-41.24c0-11.65,9.46-21.11,21.11-21.11Z"
            />
            {/* Primary Color - Vertical element */}
            <path
                fill={theme.palette.primary.main}
                stroke={theme.palette.background.paper}
                strokeMiterlimit={10}
                d="M163.55,188.12h48.76c6.62,0,12,5.38,12,12v79.87c0,.48-.39.86-.86.86h-28.76c-17.66,0-32-14.34-32-32v-59.87c0-.48.39-.86.86-.86Z"
            />
            {/* Secondary Color - Main element with dots */}
            <path
                fill={theme.palette.secondary.main}
                d="M224.26,155.9c-.01-.17-.02-.33-.02-.49v-14.56c0-12.29-9.96-22.26-22.26-22.26h-70.72c-6.6,0-11.96,5.35-11.96,11.96v26.54c0,12.29,9.96,22.26,22.26,22.26h70.54c.8.01,1.6.02,2.4.04,3.27.05,6.4,1.67,8.07,4.48.13.22.26.45.37.68.02.04.03.08.05.12.26.79,1.22,1.99,1.22,1.14l.02-6.46h0v-2.27l.07-20.39c-.01-.26-.03-.52-.04-.78ZM151.68,156.13c-3.52,0-6.37-2.85-6.37-6.37s2.85-6.37,6.37-6.37,6.37,2.85,6.37,6.37-2.85,6.37-6.37,6.37ZM171.8,156.13c-3.52,0-6.37-2.85-6.37-6.37s2.85-6.37,6.37-6.37,6.37,2.85,6.37,6.37-2.85,6.37-6.37,6.37ZM191.93,156.13c-3.52,0-6.37-2.85-6.37-6.37s2.85-6.37,6.37-6.37,6.37,2.85,6.37,6.37-2.85,6.37-6.37,6.37Z"
            />
        </SvgIcon>
    );
};

export default T4loLogoIcon;
